module.exports = __webpack_public_path__ + "img/emotion.9b970bb4.png";